import Auth from '@/core/auth';
import MRole from '@/core/roles'

const auth = {
  data () {
    return {
      role: MRole
    }
  },
  methods: {
    can (task) {
      return this.role.can(this.user.role, task);
    }
  },
  computed: {
    user: Auth.getUser
  }
}
export default auth
